import moment from 'moment'

export const formatQualificationDateToPqe = input => {
  if (!input) return '-'

  const now = moment(new Date())
  const qualified = moment(new Date(input))

  const differenceInMonths = now.diff(qualified, 'months') % 12
  const qualifiesInFuture = now.isBefore(qualified)
  if (qualifiesInFuture) {
    const yearsOffset = differenceInMonths <= -6 ? 1 : 0
    const years = now.diff(qualified, 'years') + yearsOffset
    const months = differenceInMonths <= -6 ? '0' : '5'
    const asString = `-${years}.${months}`.replace('--', '-')
    const asFloat = Number.parseFloat(asString)
    return asFloat <= -2.5 ? -2.5 : asFloat
  }

  const years = `${now.diff(qualified, 'years')}`
  const months = differenceInMonths >= 6 ? '5' : '0'
  const asFloat = Number.parseFloat(`${years}.${months}`)
  return asFloat >= 11 ? 11 : asFloat
}



// WEBPACK FOOTER //
// ./scripts/shared/services/format-pqe.js